/**
 * Shared column-grid templates for the Coverage list tables. Each header row and its data rows MUST
 * use the same template or their cells will misalign — keep them in one place (the Coverage twin of
 * `issues/issue-table-grid.ts`).
 *
 * Both tables are responsive to the LIST CONTAINER (`@container/list`, declared on the scroll body in
 * `CoverageListBody`), never the viewport: below the breakpoint the wide fixed-track columns collapse
 * so the grid's fixed floor always fits a `PANEL_MIN_PX` (400px) Split panel.
 * Sites — compact: Site · Status · open-affordance; wide (≥560px): + Location · Last survey · Coverage.
 * Officers — compact: Officer · Sites · Completion; wide (≥480px): + Progress bar.
 * Cells that only exist in the wide template take the matching `*_COL_WIDE` display classes.
 */
export const SITE_TABLE_COLS =
  'grid grid-cols-[minmax(0,2.4fr)_96px_24px] @[560px]/list:grid-cols-[minmax(0,2.4fr)_minmax(0,1.4fr)_74px_112px_96px_24px] items-center gap-3'
export const SITE_COL_WIDE = 'hidden @[560px]/list:block'
export const SITE_COL_WIDE_FLEX = 'hidden @[560px]/list:flex'

export const OFFICER_TABLE_COLS =
  'grid grid-cols-[minmax(0,2.4fr)_52px_64px] @[480px]/list:grid-cols-[minmax(0,2.4fr)_52px_minmax(0,1.6fr)_64px] items-center gap-3'
export const OFFICER_COL_WIDE = 'hidden @[480px]/list:block'
